import { render, staticRenderFns } from "./kiosk-bank-alone.vue?vue&type=template&id=06c3df00&scoped=true&"
import script from "./kiosk-bank-alone.vue?vue&type=script&lang=js&"
export * from "./kiosk-bank-alone.vue?vue&type=script&lang=js&"
import style0 from "./kiosk-bank-alone.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./kiosk-bank-alone.vue?vue&type=style&index=1&id=06c3df00&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "06c3df00",
  null
  
)

export default component.exports